import { RendererLike } from "@connectv/html";

export function Space(_: {}, renderer: RendererLike<unknown, unknown>) {
  return <fragment/>
}
